<template>
  <Navbar></Navbar>
  <div class="product-detail-page">
    <div class="detail-banner">
      <div class="img-box detail-banner-img"><img src="/assets/product/engine/4B15E/4B15E.jpg" alt=""></div>
      <div class="detail-banner-r">

        <div class="detail-banner-t2">4B15E 1.5T混动专用汽油发动机</div>
        <div class="detail-banner-desc">
          4B15E发动机为新一代1.5T高热效率混动专用汽油发动机，该款发动机采用了全新的混合动力燃烧架构，匹配DHT变速器，适用于轿车、SUV、MPV；<br />
          应用多项创新技术，使发动机更先进、具有更强的动力和更低的燃油消耗率。
        </div>
        <!-- <a href="/contact-us.html" class="detail-banner-btn">
          <div>联系我们</div><img src="/assets/index/right.png" alt="">
        </a> -->
      </div>
    </div>

    <div class="detail-box">
      <div class="detail-title">核心参数</div>
      <div class="detail-utils">
        <div class="detail-utils-item">
          <div class="detail-utils-d">最大功率</div>
          <div class="detail-utils-u">123kW</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">最大扭矩</div>
          <div class="detail-utils-u">243N·m</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">工程热效率</div>
          <div class="detail-utils-u">41.5%</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">排放水平</div>
          <div class="detail-utils-u">国6b</div>
        </div>
      </div>
    </div>

    <div class="detail-box">
      <div class="detail-title">核心技术</div>

      <div class="detail-four-list">
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/4B15E/4B15E-1.jpg" alt=""></div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">LP-EGR系统</div>
          <div class="detail-four-desc">
            废气再循环系统可将燃烧后的废气引入气缸，提升缸内混合气的热容量，降低缸内燃烧温度，从而降低NOX排放。并且可以降低缸内燃烧温度，改善缸内爆震，同时爆震倾向的降低，可进一步提升压缩比，改善油耗。燃烧温度的降低，还可降低排温，拓展当量空燃比区域，减少CO排放。
          </div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">米勒循环+VGT增压器</div>
          <div class="detail-four-desc">
            米勒循环控制进气门早关，可以使发动机膨胀比大于压缩比，在膨胀行程中可最大限度的将热能转化为机械能，同时可以降低部分负荷泵气损失，降低油耗。<br />
            为匹配米勒循环实现高速性能，采用VGT增压器，并且经过材料升级，提高耐温至980℃，避免发动机全负荷工况下零部件保护加浓，实现λ=1。
          </div>
        </div>
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/4B15E/4B15E-2.jpg" alt=""></div>
        </div>
      </div>
    </div>

    <div class="detail-box detail-bottom-bgs">
      <div class="detail-updown-list">
        <div class="detail-updown-item">
          <div class="detail-updown-title">350bar中置直喷</div>
          <div class="detail-updown-desc">
            中置喷油器减少燃油湿壁，避免机油稀释。350bar燃油喷射系统有效减小油束直径，加快燃油雾化；可实现3次喷射，减少PN排放。</div>
          <div class="img-box"><img src="/assets/product/engine/4B15E/4B15E-3.jpg" alt=""></div>
        </div>
        <div class="detail-updown-item">
          <div class="detail-updown-title">电子水泵+电子节温器</div>
          <div class="detail-updown-desc">
            根据冷却需求，采用400W电子水泵，使发动机按需冷却，降低能耗，同时配合电子节温器，快速响应，精确控制发动机水温，可实现发动机全map水温可控，具有更灵活的热管理控制策略。<br />
            有效加速发动机暖机，降低传热损失。小负荷工况运行流量需求较小时，可降速运行，减少能耗；满负荷工况冷却能力更强，适应整车热害、爬坡急停等特殊工况。</div>
          <div class="img-box"><img src="/assets/product/engine/4B15E/4B15E-4.jpg" alt=""></div>
        </div>
      </div>
    </div>

    <div class="detail-swiper-list detail-box ">
      <div class="sw-page swiper-pagination"></div>
      <div class="detail-swiper-left">
        <div class="detail-tabs">
          <div class="detail-tab-item active">
            <div class="detail-tab-title">缸盖集成排气歧管技术</div>
            <div class="detail-tab-desc">
              零部件数量减少，重量降低23%，整机结构紧凑，减轻整机重量，并且在冷启动时能够加快冷却水升温速度，提高发动机预热性能，减少排气能量损耗，加快热机时间，可有效降低发动机燃油消耗率及排放。</div>
          </div>
          <div class="detail-tab-item">
            <div class="detail-tab-title">变排量机油泵</div>
            <div class="detail-tab-desc">
              可以根据发动机的转速和负荷调整机油压力，降低发动机0.5%～2%的燃油消耗，高转速工况最多能降低3%的燃油消耗。</div>
          </div>
        </div>
        <div class="detail-swiper-utils">
          <div class="detail-swiper-util-item">
            <div class="detail-swiper-n">
              23%
            </div>
            <div class="detail-swiper-d">
              重量降低
            </div>
          </div>
          <div class="detail-swiper-util-item">
            <div class="detail-swiper-n">
              0.5%～2%
            </div>
            <div class="detail-swiper-d">
              发动机燃油消耗降低
            </div>
          </div>
        </div>
      </div>
      <div class="detail-swiper-right swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide img-box"><img src="/assets/product/engine/4B15E/4B15E-5.jpg" alt=""></div>
          <div class="swiper-slide img-box"><img src="/assets/product/engine/4B15E/4B15E-6.jpg" alt=""></div>
        </div>
      </div>
    </div>


  </div>
  <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
  nextTick(() => {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach((container, index) => {
      const containerKey = `swiper_${index}`;
      container.dataset.swiperKey = containerKey;
      const swiperInstance = new Swiper(container, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        preventClicks: true,
        effect: 'fade',
        pagination: {
          el: container.querySelector('.sw-page'),
          clickable: true,
        },
        on: {
          slideChange: function () {
            const activeIndex = this.activeIndex;
            const tabItems = document.querySelectorAll('.detail-tab-item');
            tabItems.forEach((item, index) => {
              if (index === activeIndex) {
                item.classList.add('active');
              } else {
                item.classList.remove('active');
              }
            });
          },
        },
      });
      swiperInstances.value[containerKey] = swiperInstance;
    });

    bindTabClickEvent();
  });
});
function bindTabClickEvent() {
  const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

  allSwiperLists.forEach((swiperList) => {
    const tabItems = swiperList.querySelectorAll('.detail-tab-item');
    const targetSwiperContainer = swiperList.querySelector('.swiper-container');

    if (!tabItems.length || !targetSwiperContainer) return;

    const containerKey = targetSwiperContainer.dataset.swiperKey;
    const targetSwiper = swiperInstances.value[containerKey];
    if (!targetSwiper) return;

    const handleTabAction = (tabItem, localTabIndex) => {
      tabItems.forEach(item => item.classList.remove('active'));
      tabItem.classList.add('active');
      targetSwiper.slideTo(localTabIndex, 300, true);
    };
    tabItems.forEach((tabItem, localTabIndex) => {
      const handleTabClickWrapper = () => {
        handleTabAction(tabItem, localTabIndex);
      };
      tabItem.removeEventListener('click', handleTabClickWrapper);
      tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
      tabItem.addEventListener('click', handleTabClickWrapper);
      tabItem.addEventListener('mouseenter', handleTabClickWrapper);
    });
  });
}

</script>

<script>
export const pageConfig = {
  title: '4B15E 1.5T混动专用汽油发动机 - 蜂巢汽车官网',
  keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
  description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
  outputPath: 'engine/4B15E.html'
};

import { createApp } from 'vue';
import App from './4B15E.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./4B15E.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss" scoped></style>